import { Field } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { FormFields } from '../types'
import { FormField } from '@generated'

type NewsletterFieldProps = {
  formId: string
  isNewApiStructure?: boolean
  fields?: FormFields
}

export const NewsletterField: FC<NewsletterFieldProps> = ({
  formId,
  isNewApiStructure = false,
  fields,
}) => {
  const { t } = useTranslation('forms')

  const getLabel = (): string => {
    if (!isNewApiStructure || !fields) {
      return t('labels.subscribePlazaBrilliantNews', { ns: 'forms' })
    }

    const isMandatory =
      fields.find((f) => f.type === FormField.NewsletterMandatory)?.mandatory ??
      fields.find((f) => f.type === FormField.GassanPlazaNews)?.mandatory ??
      false
    const baseLabel = t('labels.subscribePlazaBrilliantNews', { ns: 'forms' })
    return isMandatory ? baseLabel : `${baseLabel} - ${t('optional', { ns: 'forms' })}`
  }

  return (
    <Field
      id={`${formId}-plaza-brillant-news`}
      name="plazaBrilliantNews"
      label={getLabel()}
      field="checkbox"
      gridColumn="span 12"
    />
  )
}
